<div class="row content__grid">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box">
      <div class="row align-items-center">
        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
          <h4 class="page-title content__title">
            Control de Reservas
          </h4>
        </div>
        <div class=" col-lg-8 col-md-6 col-sm-6 col-12 content__boxBtnHead">
          <!-- <div class="content__subhead__inputGrid">
            <div class="input-group">
              <span class="input-group-prepend"><span class="input-group-text content__subhead__inputGrid__title">
                  <i class="fas fa-list-alt m-r-3"></i>Listar</span></span>
              <select class="form-control content__subhead__inputGrid__input" ng-model="viewSelected" id="viewSelected"
                ng-change="changeViewSelected(viewSelected)" ng-options="type.description for type in menu_options">
              </select>
            </div>
          </div> -->

          <ng-container>
            <a routerLink="/{{branchofficeSlug}}/reservashotel/reservas/nuevo" class="btn btn-primary">
              <i class="fa fa-plus m-r-5"></i> Agregar reserva </a>
          </ng-container>
        </div>
      </div>

      <div class="row align-items-center m-t-10">
        <div class="col-lg-7 col-md-7 col-sm-6 col-12 content__subhead__boxBtns">
          <button type="button" class="btn btn-light waves-effect" title="Actualizar" (click)="refresh()">
            <i class="fas fa-undo"></i></button>
          <div class="content__subhead__inputGrid">
            <div class="input-group" style="width: 105%;">
              <span class="input-group-prepend">
                <span class="input-group-text content__subhead__inputGrid__title">
                  <i class="far fa-calendar-alt"></i>
                </span>
              </span>
              <input type="text" id="date_range" class="form-control content__subhead__inputGrid__input">
            </div>
          </div>
        </div>
        <div class="col-lg-5 col-md-5 col-sm-6 col-12">
          <component-search (searchEvent)="search($event)"></component-search>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12 m-t-0">
    <div class="row m-b-20">
      <div class="col-lg-2">
        <div class="card border border-primary m-b-0">
          <div class="card-header bg-transparent border-primary" style="padding: 5px 10px;">
            <h5 class="my-0 text-primary f-s-14"><i class="fas fa-mug-hot me-3"></i> Desayunos ({{total_breakfast}})
              <a target="_blank"
                href="/{{branchofficeSlug}}/api/hotelbooking/export/breakfast/pdf?start_range={{start_range | date:'yyyy-MM-dd'}}"
                class="float-right text-danger pointer">
                <i class="far fa-file-pdf "></i>
              </a>
            </h5>
          </div>
        </div>
      </div>
      <div class="col-lg-2">
        <div class="card border border-primary m-b-0">
          <div class="card-header bg-transparent border-primary" style="padding: 5px 10px;">
            <h5 class="my-0 f-s-14" style="color: #8f0f32;">
              <!-- <div class="alert_booking f-s-11" data-toggle="tooltip" data-placement="right"
              data-original-title="CHECK-IN el día de hoy" style="top: 6px;"><i class="fas fa-info-circle"></i></div> -->
              CHECK-IN ({{total_checkin}})
              <i class="fas fa-info-circle float-right f-s-14" data-toggle="tooltip" data-placement="right"
                data-original-title="CHECK-IN reservas" style="color: #8f0f32;"></i>
            </h5>
          </div>
        </div>
      </div>
      <div class="col-lg-2">
        <div class="card border border-primary m-b-0">
          <div class="card-header bg-transparent border-primary" style="padding: 5px 10px;">
            <h5 class="my-0 f-s-14 text-dark">
              <!-- <div class="alert_booking_out f-s-11" data-toggle="tooltip" data-placement="right"
              data-original-title="CHECK-OUT el día de hoy" style="top: 6px;"><i class="fas fa-exclamation-triangle"></i></div> -->
              CHECK-OUT ({{total_checkout}})
              <i class="fas fa-exclamation-triangle float-right f-s-14" data-toggle="tooltip" data-placement="right"
                data-original-title="CHECK-OUT reservas"></i>
            </h5>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <ng-container *ngIf="items.length > 0">
        <div class="col-lg-2 col-md-2 col-2 p-l-5 p-r-5" *ngFor="let item of items; let index_ = index">
          <div class="card group__item tour border-color_{{item.status_class}}">
            <div class="card-header group__item__header">
              <div class="flex p-0">
                <div class="flex-35 group__item__header__code f-s-14">
                  HAB: {{item.bedroom.code_number}}
                </div>
                <div class="flex-60 text-right">
                  <span class="badge badge-light f-s-12 bold">
                    {{item.roomtype.description}}
                  </span>
                </div>
              </div>
            </div>
            <div class="card-body group__item__body">
              <ng-container *ngIf="
              item.is_checkin &&
              !item.is_checkout &&
              isBefore(item.date_checkout, date_now)
              ">
                <div class="position-relative m-b-5">
                  <span class="badge badge-dark f-s-13">CHECK-OUT PENDIENTE, <br> Salida
                    {{item.date_checkout | date:'yyyy-MM-dd'}}</span>
                  <div class="alert_booking_out"><i class="fas fa-exclamation-triangle"></i></div>
                </div>
              </ng-container>

              <ng-container *ngIf="
              !item.is_checkin &&
              isBefore(item.date_checkin, date_now)
              ">
                <div class="position-relative m-b-5">
                  <span class="badge badge-warning f-s-13">CHECK-IN PENDIENTE, <br> Ingresó
                    {{item.date_checkin | date:'yyyy-MM-dd'}}</span>
                  <div class="alert_booking"><i class="fas fa-info-circle"></i></div>
                </div>
              </ng-container>

              <div class="group__item__body__item f-s-12 position-relative">
                <span class="bold">{{item.booking_data.code}}</span>
                <ng-container
                  *ngIf="!item.is_checkin && (item.date_checkin | date:'yyyy-MM-dd') === (date_now | date:'yyyy-MM-dd')">
                  <div class="alert_booking"><i class="fas fa-info-circle"></i>
                  </div>
                </ng-container>
                <ng-container
                  *ngIf="item.is_checkin && !item.is_checkout && (item.date_checkout | date:'yyyy-MM-dd') === (date_now | date:'yyyy-MM-dd')">
                  <div class="alert_booking_out" data-toggle="tooltip" data-placement="right"
                    data-original-title="CHECK-OUT el día de hoy"><i class="fas fa-exclamation-triangle"></i>
                  </div>
                </ng-container>


              </div>
              <div class="group__item__body__item f-s-10">
                <i class="fas fa-user-tie m-r-5 "></i>{{item.booking_data.client_data.fullname}}
                <p class="bold f-s-9 m-b-0 ">N° DOC :
                  {{item.booking_data.client_data.document}}
                </p>
              </div>
              <div class="group__item__body__item f-s-11 m-b-5">
                <i class="fas fa-phone m-r-5"></i>
                {{item.booking_data.client_data.cellphone}}
              </div>
              <div class="group__item__body__item f-s-12 bold text-primary">
                <i class="fas fa-calendar-alt m-r-5 "></i>CHECK-IN : <span
                  class="m-l-10">{{item.date_checkin | date: 'mediumDate'}}</span>
              </div>
              <div class="group__item__body__item f-s-12 bold text-danger">
                <i class="fas fa-calendar-minus m-r-5 "></i>CHECK-OUT : {{item.date_checkout | date: 'mediumDate'}}
              </div>
              <div class="group__item__body__item f-s-12 bold text-dark">
                <i class="fas fa-moon m-r-5 "></i>Noches : {{item.number_nights}}
                <i class="fas fa-user-alt m-l-15"></i> PAX : {{item.nro_pax}}
              </div>
            </div>
            <div class="card-footer group__item__footer bg-{{item.status_class}}">
              <div class="badge group__item__footer__check">
                <p class="text-uppercase m-b-0 text-white"><span class="bold f-s-12">{{item.checkin_status}}</span>
                  <ng-container *ngIf="!item.is_checkin">
                    <button class="btn btn-sm btn-light f-s-10 bold m-l-4" (click)="checkIn(item)">
                      <i class="fas fa-check" style="color:#8f0f32"></i>
                    </button>
                  </ng-container>
                  <!-- <ng-container *ngIf="item.is_checkin && !item.is_checkout">
                    <button class="btn btn-sm btn-dark f-s-10 bold m-l-4" (click)="checkOut(item)">
                      <i class="fas fa-sign-out-alt"></i>
                    </button>
                  </ng-container> -->
                </p>
              </div>
              <button class="btn btn-sm btn-light f-s-10 bold" (click)="detail(item.booking_id)">
                Detalle
                <!-- <i class="far fa-hand-point-right"></i> -->
                <i class="far fa-hand-point-up"></i>
              </button>
            </div>
          </div>
        </div>
      </ng-container>
      <div *ngIf="items.length == 0" class="col-12 text-center p-t-80">
        <i class="fas fa-list-alt f-s-50"></i>
        <p class="m-t-10 f-s-20">No se encontraron reservas para las fechas y vista seleccionada</p>
      </div>
    </div>
  </div>
</div>
